import { FunctionComponent } from 'react';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import { getRoutes } from 'utils/locale';
import { parseToQueryString } from 'utils/querystring';
import { withVariables } from 'utils/string';

import LayoutContainer from 'components/layout/LayoutContainer';
import Pagination from 'components/layout/Pagination';
import MediumArticleBox from 'components/modules/public/layout/articles/MediumArticleBox';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageCategoryArticlesEmployeeSectionArticles: FunctionComponent<Props> = ({
    layoutContainerProps,
    articles,
    meta,
    onSearch,
    translations: { iconsAlts },
}) => {
    const router = useRouter();
    const routes = getRoutes();
    const articleCategory = articles[0]?.category?.slug;

    return (
        <StyledComponent
            className="public-page-category-articlesemployee-section-articles"
        >
            <LayoutContainer
                {...layoutContainerProps}
            >
                <h1
                    className="headline"
                    dangerouslySetInnerHTML={{ __html: articles[0].category.name }}
                />
                <div
                    className="article-boxes"
                >
                    {Array.isArray(articles) && articles.length > 0 && articles.map(element => (
                        <MediumArticleBox
                            key={element?.id}
                            article={element}
                            iconsAlts={iconsAlts}
                        />
                    ))}
                </div>
                <Pagination
                    currentPage={meta.currentPage}
                    lastPage={meta.lastPage}
                    onPageChange={(nextPage: number) => {
                        if(nextPage === meta.currentPage) {
                            return;
                        }
                        const path = parseToQueryString(withVariables(routes?.blogCategory, { articleCategorySlug: articleCategory }), { page: nextPage.toString() });
                        onSearch({ page: nextPage });
                        return router.push(path);
                    }}
                    hrefBuilder={(currentPage: number)=>{
                        return    parseToQueryString(withVariables(routes?.blogCategory, { articleCategorySlug: articleCategory }), { page: currentPage.toString() });
                    }}
                />
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageCategoryArticlesEmployeeSectionArticles;